var globalLocalizationStrings = {
  en: {
    chartResultsComponent: {
      yourNonAnswer: 'This question was not applicable to you.',
      yourAnswer: 'You answered:',
      positiveAnswer: 'Yes',
      negativeAnswer: 'No'
    },
    feedbackComponent: {
      cardHeader: 'How do you feel about this presentation?',
      goodText: 'Good',
      mehText: 'Meh',
      badText: 'Bad',
      cardText: 'Thank you for your feedback! Feel free to drop us an email at <a href="mailto:jenny@healint.com" style="color:#26deca;">jenny@healint.com</a> with any further questions.'
    },
    actionButtonText: {
      backButton: 'Back',
      startButton: 'Start',
      okButton: 'OK',
      seeAnswersButton: 'See Answers',
      allDoneButton: 'All Done!'
    },
    surveyCardComponent: {
      answerAvailableText: 'See results after answering',
      answerUnavailableText: 'See answers on'
    },
    rewardsComponent: {
      rewardsLine1: 'Thank you for contributing to research!',
      rewardsLine2: 'Check back later for new content ^_^'
    },
    resultsView: {
      nextSurvey: 'New Survey Available'
    }
  },
  fr: {
    chartResultsComponent: {
      yourNonAnswer: 'Vous n\'avez pas répondu à cette question',
      yourAnswer: 'Votre réponse :',
      positiveAnswer: 'Oui',
      negativeAnswer: 'Non'
    },
    feedbackComponent: {
      cardHeader: 'Que pensez-vous des résultats présentés ?',
      goodText: 'J\'aime !',
      mehText: 'Bof',
      badText: 'Je suis déçu·e',
      cardText: 'Merci d\'avoir répondu ! N\'hésitez pas à nous écrire à l\'adresse suivante : <a href="mailto:jenny@healint.com" style="color:#26deca;">jenny@healint.com</a> pour nous en dire plus !'
    },
    actionButtonText: {
      backButton: 'Retour',
      startButton: 'Démarrer',
      okButton: 'OK',
      seeAnswersButton: 'Voir les réponses',
      allDoneButton: 'Terminé'
    },
    surveyCardComponent: {
      answerAvailableText: 'Voir les résultats après avoir répondu au questionnaire',
      answerUnavailableText: 'Voir les réponses le'
    },
    rewardsComponent: {
      rewardsLine1: 'Merci pour votre participation !',
      rewardsLine2: 'Merci de revenir ultérieurement pour répondre à de nouvelles questions !'
    },
    resultsView: {
      nextSurvey: 'Nouvelle enquête disponible'
    }
  },
  pt: {
    chartResultsComponent: {
      yourNonAnswer: 'Você não respondeu a esta questão.',
      yourAnswer: 'Você respondeu:',
      positiveAnswer: 'Sim',
      negativeAnswer: 'Não'
    },
    feedbackComponent: {
      cardHeader: 'Como você se sente sobre esse relatório?',
      goodText: 'Bom',
      mehText: 'Meh',
      badText: 'Mau',
      cardText: 'Obrigado pelo seu feedback! Esteja à vontade para nos enviar um email para <a href="mailto:jenny@healint.com" style="color:#26deca;">jenny@healint.com</a>  com quaisquer questões.'
    },
    actionButtonText: {
      backButton: 'Voltar',
      startButton: 'Começar',
      okButton: 'OK',
      seeAnswersButton: 'Veja as respostas',
      allDoneButton: 'Está tudo feito'
    },
    surveyCardComponent: {
      answerAvailableText: 'Veja os resultados depois de responder',
      answerUnavailableText: 'Respostas em'
    },
    rewardsComponent: {
      rewardsLine1: 'Obrigado por contribuir para a pesquisa!',
      rewardsLine2: 'Verifique mais tarde para novo conteúdo ^_^'
    },
    resultsView: {
      nextSurvey: 'Nova pesquisa disponível'
    }
  },
  ja: {
    chartResultsComponent: {
      yourNonAnswer: 'この質問には回答していません。',
      yourAnswer: '回答済みです:',
      positiveAnswer: 'はい',
      negativeAnswer: 'いいえ'
    },
    feedbackComponent: {
      cardHeader: 'このプレゼンテーションについて、どのように感じますか？',
      goodText: '良い',
      mehText: 'まぁまぁ',
      badText: '悪い',
      cardText: 'ご意見をありがとうございます！他にもご質問がありましたら、どうぞご遠慮なく <a href="mailto:jenny@healint.com" style="color:#26deca;">jenny@healint.com</a> までメールをお送りください。'
    },
    actionButtonText: {
      backButton: '戻る',
      startButton: '開始',
      okButton: 'OK',
      seeAnswersButton: '回答を見る',
      allDoneButton: '完了しました'
    },
    surveyCardComponent: {
      answerAvailableText: '回答後の結果を見る',
      answerUnavailableText: '回答閲覧可能日'
    },
    rewardsComponent: {
      rewardsLine1: 'リサーチへのご協力をありがとうございます！',
      rewardsLine2: '新しいコンテンツをまた見に来てください ^_^'
    },
    resultsView: {
      nextSurvey: '新しい調査'
    }
  },
  es: {
    chartResultsComponent: {
      yourNonAnswer: 'Usted no respondió esta pregunta.',
      yourAnswer: 'Usted respondió:',
      positiveAnswer: 'Sí',
      negativeAnswer: 'No'
    },
    feedbackComponent: {
      cardHeader: '¿Qué piensa de esta presentación?',
      goodText: 'Buena',
      mehText: 'Da igual',
      badText: 'Mala',
      cardText: '¡Gracias por tus comentarios! Si tiene más preguntas, no dude en enviarnos un correo electrónico a <a href="mailto:jenny@healint.com" style="color:#26deca;">jenny@healint.com</a> '
    },
    actionButtonText: {
      backButton: 'Atrás',
      startButton: 'Comenzar',
      okButton: 'OK',
      seeAnswersButton: 'Ver Respuestas',
      allDoneButton: 'Hecho'
    },
    surveyCardComponent: {
      answerUnavailableText: 'Ver resultados el',
      answerAvailableText: 'Vea los resultados después de responder'
    },
    rewardsComponent: {
      rewardsLine1: '¡Gracias por contribuir a la investigación!',
      rewardsLine2: 'Vuelva después para ver el nuevo contenido ^_^'
    },
    resultsView: {
      nextSurvey: 'Nueva encuesta disponible'
    }
  },
  de: {
    chartResultsComponent: {
      yourNonAnswer: 'Sie haben diese Frage nicht beantwortet.',
      yourAnswer: 'Sie antworteten mit:',
      positiveAnswer: 'Ja',
      negativeAnswer: 'Nein'
    },
    feedbackComponent: {
      cardHeader: 'Was halten Sie von dieser Präsentation?',
      goodText: 'Gut',
      mehText: 'Mittelmäßig',
      badText: 'Schlecht',
      cardText: 'Vielen Dank für Ihre Bewertung! Schicken Sie uns bei weiteren Fragen jederzeit eine E-Mail an  <a href="mailto:jenny@healint.com" style="color:#26deca;">jenny@healint.com</a>.'
    },
    actionButtonText: {
      backButton: 'Zurück',
      startButton: 'Start',
      okButton: 'OK',
      seeAnswersButton: 'Siehe Antworten',
      allDoneButton: 'Fertig'
    },
    surveyCardComponent: {
      answerUnavailableText: 'Antworten verfügbar am',
      answerAvailableText: 'Siehe Resultate nach der Beantwortung'
    },
    rewardsComponent: {
      rewardsLine1: 'Vielen Dank für Ihren Beitrag zur Forschung!',
      rewardsLine2: 'Kommen Sie später wieder für neue Inhalte ^_^'
    },
    resultsView: {
      nextSurvey: 'Neue Umfrage verfügbar'
    }
  },
  nl: {
    chartResultsComponent: {
      yourNonAnswer: 'U heeft deze vraag niet beantwoord.',
      yourAnswer: 'U heeft geantwoord:',
      positiveAnswer: 'Ja',
      negativeAnswer: 'Nee'
    },
    feedbackComponent: {
      cardHeader: 'Hoe voelt u zich over deze presentatie?',
      goodText: 'Goed',
      mehText: 'Neutraal',
      badText: 'Slecht',
      cardText: 'Bedankt voor uw feedback! Twijfel niet om ons te e-mailen op <a href="mailto:jenny@healint.com" style="color:#26deca;">jenny@healint.com</a> als u aanvullende vragen heeft.'
    },
    actionButtonText: {
      backButton: 'Terug',
      startButton: 'Start',
      okButton: 'OK',
      seeAnswersButton: 'Zie Antwoorden',
      allDoneButton: 'Helemaal Klaar'
    },
    surveyCardComponent: {
      answerUnavailableText: 'Zie antwoorden op',
      answerAvailableText: 'Zie resultaten na het beantwoorden'
    },
    rewardsComponent: {
      rewardsLine1: 'Bedankt voor het bijdragen aan onderzoek!',
      rewardsLine2: 'Kom later terug voor nieuw materiaal ^_^'
    },
    resultsView: {
      nextSurvey: 'Nieuwe enquête beschikbaar'
    }
  },
  it: {
    chartResultsComponent: {
      yourNonAnswer: 'Non hai risposto alla domanda.',
      yourAnswer: 'Hai risposto:',
      positiveAnswer: 'Sì',
      negativeAnswer: 'No'
    },
    feedbackComponent: {
      cardHeader: 'Come ti sembra questa presentazione?',
      goodText: 'Buona ',
      mehText: 'Così così',
      badText: 'Pessima',
      cardText: 'Grazie per il tuo feedback! Se vuoi avere ulteriori informazioni puoi mandarci un\'email a <a href="mailto:jenny@healint.com" style="color:#26deca;">jenny@healint.com</a> .'
    },
    actionButtonText: {
      backButton: 'Indietro',
      startButton: 'Avanti',
      okButton: 'OK',
      seeAnswersButton: 'Vedi risposte',
      allDoneButton: 'Fatto'
    },
    surveyCardComponent: {
      answerUnavailableText: 'Risposte disponibili al',
      answerAvailableText: 'Vedi i risultati dopo aver risposto'
    },
    rewardsComponent: {
      rewardsLine1: 'Grazie per il tuo contributo all\'indagine!',
      rewardsLine2: 'Torna in questa sezione più avanti per nuovi contenuti'
    },
    resultsView: {
      nextSurvey: 'Nuovo sondaggio disponibile'
    }
  },
  ko: {
    chartResultsComponent: {
      yourNonAnswer: '이 질문에 답변하지 않았습니다.',
      yourAnswer: '답변:',
      positiveAnswer: '네',
      negativeAnswer: '아니오'
    },
    feedbackComponent: {
      cardHeader: '이 프레젠테이션에 대해 어떻게 생각하십니까?',
      goodText: '좋음',
      mehText: '보통',
      badText: '나쁨',
      cardText: '피드백을 주셔서 감사합니다! 질문이 있으시다면 <a href="mailto:jenny@healint.com" style="color:#26deca;">jenny@healint.com</a> 으로 이메일을 보내주시기 바랍니다.'
    },
    actionButtonText: {
      backButton: '돌아가기',
      startButton: '시작',
      okButton: 'OK',
      seeAnswersButton: '답변 보기',
      allDoneButton: '완료'
    },
    surveyCardComponent: {
      answerUnavailableText: '결과 공표 일 :',
      answerAvailableText: '답변 후 결과 보기'
    },
    rewardsComponent: {
      rewardsLine1: '리서치에 도움을 주셔서 감사합니다!',
      rewardsLine2: '새로운 컨텐츠를 보려면 나중에 다시 돌아오세요'
    },
    resultsView: {
      nextSurvey: '신규조사'
    }
  }
}

export default globalLocalizationStrings



// WEBPACK FOOTER //
// ./src/store/localization/globalLocalizationStrings.js